import { Translation } from '@ps/web-shared-components';
import React from 'react';

import useWizardExit from '@swf/core/hooks/useWizardExit';

import Container from '../../../Container/Container';

import {
  TXTCLI_SorryX_we_cannot_approve_you_f_ELL,
  TXTWCL_Account_declined
} from './SignupBlackListedUser.messages.json';

const SignupBlackListedUser: React.FC = () => {
  const exitWizard = useWizardExit();

  return (
    <Container
      page={SignupBlackListedUser}
      headerProps={{
        title: <Translation {...TXTWCL_Account_declined} />,
        buttons: {
          back: false,
          exitWizardOnBackClick: false,
          onCloseClick: exitWizard
        }
      }}
      pageTopTitle={<Translation {...TXTWCL_Account_declined} />}
      pageTopSubtitle={<Translation {...TXTCLI_SorryX_we_cannot_approve_you_f_ELL} />}
    />
  );
};

SignupBlackListedUser.displayName = 'SignupBlackListedUser';

export default SignupBlackListedUser;
